import React, { useEffect } from "react";
import { useSEO } from "../../context/SEOContext";
import ApplicationPage from "../../components/Application/Application";
import { useTranslation } from "react-i18next";
const Application = () => {
  const { t } = useTranslation();

  const setSeo = useSEO();
  useEffect(() => {
    setSeo({
      title: t("application.meta.title"),
      description: t("application.meta.description"),
      keywords: t("application.meta.keywords"),
      siteName: "Touch Of Soul",
      favicon: "/faviconnew.png",
      ogImage:
        "https://mukemel.com/static/media/brothers.c791973cd1c46d462816.webp",
      ogUrl: "https://mukemel.com",
      ogType: "website", // ya da 'website'
    });
  }, [setSeo, t]);

  return (
    <>
      <ApplicationPage />
    </>
  );
};

export default Application;
